import clsx from 'clsx';
import type { ReactNode } from 'react';

import styles from './DescriptionList.module.css';

export type DescriptionListItem = {
  term: ReactNode;
  value: ReactNode;
};

type Props = {
  items: DescriptionListItem[];
  className?: string;
};

export function DescriptionList({ items, className }: Props) {
  if (items.length === 0) return null;

  return (
    <div className={clsx(styles.list, className)}>
      {items.map((item, index) => (
        <dl key={index}>
          <dt>{item.term}</dt>
          <dd>{item.value}</dd>
        </dl>
      ))}
    </div>
  );
}
